export default __webpack_public_path__ + "static/media/GroupLogo.02fb01c3.png";